import SelectedStoreBase from "./selectedStoreBase";
import SingleSelectedProperty from "./singleSelectedProperty";
import User from "../../models/user";
import Organization from "../../models/organization";
import Application from "../../../formability/document_management/models/application";

export default class GloballySelected extends SelectedStoreBase {
  static currentUser = new SingleSelectedProperty('currentUser', () => User);
  static organization = new SingleSelectedProperty('organization', () => Organization);
  static application = new SingleSelectedProperty('application', () => Application);
}